import type { ConversationTopicDetailDto } from '../api/types';
type Entry = ConversationTopicDetailDto['transcript'][number];

/** Streaming chunks share a causal submission; show one readable message, retain the source unchanged. */
export function topicMessages(entries: readonly Entry[], sources: readonly { id: string; text?: string }[] = []): Entry[] {
  const humanSources = new Map(sources.filter(source => typeof source.text === 'string').map(source => [source.id, source.text]));
  const messages: Entry[] = [];
  for (const entry of entries) {
    // Legacy ACP replay could label its own prompt as user text. The accepted submission is authoritative.
    if (entry.role === 'user' && entry.submissionId && humanSources.has(entry.submissionId)
      && entry.text !== humanSources.get(entry.submissionId)) continue;
    const last = messages.at(-1);
    if (
      entry.role === 'assistant' &&
      last?.role === 'assistant' &&
      entry.submissionId &&
      last.submissionId === entry.submissionId
    ) {
      last.text += entry.text;
    } else messages.push({ ...entry });
  }
  return messages;
}
